import { render } from "./DeleteDeviceModal.vue?vue&type=template&id=4ba261f0"
import script from "./DeleteDeviceModal.vue?vue&type=script&lang=js"
export * from "./DeleteDeviceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__